<template>
  <div :class="name" v-if="selectedRow">
    <el-dialog title="사용자 예외 권한 수정 확인"
               :visible.sync="dialogVisible"
               width="80%">
      <div>
        <!--{{selectedRow}}-->
        <h3>{{selectedRow.name}} ( <a :href="`mailto:${selectedRow.email}`" target="_blank"> {{selectedRow.email}} </a> )
        </h3>
        <ul>
          <li v-for="(affiliatedTeam, affiliatedTeamId) in selectedRow.affiliatedTeams"
              :key="affiliatedTeamId">

            {{teams[affiliatedTeam.id].name}}에 {{affiliatedTeam.division.join(',')}}의 {{affiliatedTeam.job.join(',')}}일을 수행.
          </li>
        </ul>
      </div>
      <el-row :gutter="24">
        <el-col :span="12">
          <h4>수정 전 업무</h4>
          <ul class="permission">
            <li v-for="(service, serviceId) in deleteAnEmptyPermissionList(permissionData)"
                :key="`service_${serviceId}`">
              {{serviceId}}
              <ul>
                <li v-for="(domain, domainId) in service"
                    :key="`domain_${domainId}`">
                  {{domainId}}
                  <ul>
                    <li v-for="(facility, facilityName) in domain"
                        :key="`facility_${facilityName}`">
                      <span :class="getClass(facility)">{{facility.id}}</span>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </el-col>
        <el-col :span="12">
          <div>
            <h4>수정 후 업무</h4>
            <ul class="permission">
              <li v-for="(service, serviceId) in deleteAnEmptyPermissionList(editPermissionData)"
                  :key="`service_${serviceId}`">
                {{serviceId}}
                <ul>
                  <li v-for="(domain, domainId) in service"
                      :key="`domain_${domainId}`">
                    {{domainId}}
                    <ul>
                      <li v-for="(facility, facilityName) in domain"
                          :key="`facility_${facilityName}`">
                        <span :class="getClass(facility)">{{facility.id}}</span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleCanCel">
          Cancel
        </el-button>
        <el-button type="primary"
                   @click="handleConfirm">
          Confirm
        </el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import getClassNameByException from '@/filters/getClassNameByException';
import getDeleteAnEmptyPermission from '@/filters/getDeleteAnEmptyPermission';
import getName from '@/mixins/getName';

export default {
  props: {
    editPermissionData: {
      type: Object,
      description: 'gamesData (containers/data)',
    },
    permissionData: {
      type: Object,
      description: 'container name',
    },
    dialogVisible: {
      type: Boolean,
      description: 'container name',
    },
    selectedRow: {
      type: Object,
      description: 'container name',
    },
  },
  filters: {
    getClassNameByException,
    getDeleteAnEmptyPermission,
  },
  mixins: [
    getName,
  ],
  components: {
  },
  computed: {
    ...mapGetters([
      'jobs',
      'games',
      'teams',
      'domains',
      'facilities',
      'menus',
      'getClassNameByException',
    ]),
  },
  mounted() {

  },
  methods: {
    deleteAnEmptyPermissionList(permissionData) {
      return getDeleteAnEmptyPermission(permissionData);
    },
    handleConfirm() {
      const returnException = [];
      let index = 0;

      Object.keys(this.editPermissionData).forEach((serviceId) => {
        Object.keys(this.editPermissionData[serviceId]).forEach((domainId) => {
          Object.keys(this.editPermissionData[serviceId][domainId]).forEach((facilityId) => {
            const facility = this.editPermissionData[serviceId][domainId][facilityId];

            console.log(serviceId, '', domainId, '', facilityId, ':', facility, '-', facility.isChange);

            if (facility.isChange) {
              index += 1;
              if (facility.isException) {

                // returnException.push(`${serviceId}-${domainId}-${facilityId}`);
              } else if (facility.selected) {
                returnException.push(`${serviceId}-${domainId}-${facilityId}`);
              } else {
                returnException.push(`${serviceId}-${domainId}-${facilityId}`);
              }
            } else if (facility.isException) {
              returnException.push(`${serviceId}-${domainId}-${facilityId}`);
            }
          });
        });
      });

      if (index > 0) {
        alert(`${index}개의 수정 있음`);
        console.log('returnException = ', returnException);
        this.$store.dispatch('SUBMIT_USER_EXCEPTION_DATA', { memberId: this.selectedRow.id, exceptionData: JSON.stringify(returnException) });
        // this.$store.dispatch('SUBMIT_USER_EXCEPTION_DATA', { memberId: '6', exceptionData: returnException });
      } else {
        alert('수정 없음');
      }

      this.closeDialog();
    },
    handleCanCel() {
      this.closeDialog();
    },
    closeDialog() {
      this.$emit('close', false);
    },
    getClass(facility) {
      return getClassNameByException(facility);
    },
    // changeFacility(domainKey, gameName, facilityName, facility) {
    //   const editFacility = this.editMemberData[domainKey][gameName][facilityName];
    //
    //   editFacility.isChange = !facility.isChange;
    // },
  },
  data() {
    return {
      name: 'ChangePermissionDialog',
      // editMemberData: {},
      // editMemberId: '',
      // teamDivision: [],
    };
  },
};
</script>

<style lang="scss">
  .permission {
    .addException {
      color: red;
    }
    .removeException {
      color: orange;
    }
    .default {
      color: blue;
    }
    .normal {
      color: black;
    }
  }
  .el-checkbox__input {
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/container/ChangePermissionDialog.vue